/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateThreadRequest,
  ListForumCategories200Response,
  ListForumThreads200Response,
  ListPostsInAThread200Response,
  ReplyToAThreadRequest,
  ShowCategory200Response,
  ShowThread200Response,
  UpdateThreadRequest,
} from '../models/index';
import {
    CreateThreadRequestFromJSON,
    CreateThreadRequestToJSON,
    ListForumCategories200ResponseFromJSON,
    ListForumCategories200ResponseToJSON,
    ListForumThreads200ResponseFromJSON,
    ListForumThreads200ResponseToJSON,
    ListPostsInAThread200ResponseFromJSON,
    ListPostsInAThread200ResponseToJSON,
    ReplyToAThreadRequestFromJSON,
    ReplyToAThreadRequestToJSON,
    ShowCategory200ResponseFromJSON,
    ShowCategory200ResponseToJSON,
    ShowThread200ResponseFromJSON,
    ShowThread200ResponseToJSON,
    UpdateThreadRequestFromJSON,
    UpdateThreadRequestToJSON,
} from '../models/index';

export interface CreateThreadOperationRequest {
    createThreadRequest: CreateThreadRequest;
}

export interface DeleteAPostownerOnlyRequest {
    forumPostId: number;
}

export interface DeleteThreadRequest {
    forumThreadId: number;
}

export interface ListPostsInAThreadRequest {
    forumThreadId: number;
}

export interface ReplyToAThreadOperationRequest {
    forumThreadId: number;
    replyToAThreadRequest: ReplyToAThreadRequest;
}

export interface ShowCategoryRequest {
    forumCategoryId: number;
}

export interface ShowThreadRequest {
    forumThreadId: number;
}

export interface UpdateThreadOperationRequest {
    forumThreadId: number;
    updateThreadRequest?: UpdateThreadRequest;
}

/**
 * ForumApi - interface
 * 
 * @export
 * @interface ForumApiInterface
 */
export interface ForumApiInterface {
    /**
     * Pass an optional `car_id` to link the thread to a car. The thread still shows up in the global forum listing; the car link is additive. The car owner or any approved contributor (see `POST /cars/{car}/contributors`) may attach a car to a thread.
     * @summary Create thread
     * @param {CreateThreadRequest} createThreadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    createThreadRaw(requestParameters: CreateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Pass an optional `car_id` to link the thread to a car. The thread still shows up in the global forum listing; the car link is additive. The car owner or any approved contributor (see `POST /cars/{car}/contributors`) may attach a car to a thread.
     * Create thread
     */
    createThread(requestParameters: CreateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete a post (owner only)
     * @param {number} forumPostId The ID of the forumPost.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    deleteAPostownerOnlyRaw(requestParameters: DeleteAPostownerOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Delete a post (owner only)
     */
    deleteAPostownerOnly(requestParameters: DeleteAPostownerOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete thread
     * @param {number} forumThreadId The ID of the forumThread.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    deleteThreadRaw(requestParameters: DeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Delete thread
     */
    deleteThread(requestParameters: DeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List forum categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    listForumCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForumCategories200Response>>;

    /**
     * 
     * List forum categories
     */
    listForumCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForumCategories200Response>;

    /**
     * 
     * @summary List forum threads
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    listForumThreadsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForumThreads200Response>>;

    /**
     * 
     * List forum threads
     */
    listForumThreads(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForumThreads200Response>;

    /**
     * 
     * @summary List posts in a thread
     * @param {number} forumThreadId The ID of the forumThread.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    listPostsInAThreadRaw(requestParameters: ListPostsInAThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPostsInAThread200Response>>;

    /**
     * 
     * List posts in a thread
     */
    listPostsInAThread(requestParameters: ListPostsInAThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPostsInAThread200Response>;

    /**
     * 
     * @summary Reply to a thread
     * @param {number} forumThreadId The ID of the forumThread.
     * @param {ReplyToAThreadRequest} replyToAThreadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    replyToAThreadRaw(requestParameters: ReplyToAThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Reply to a thread
     */
    replyToAThread(requestParameters: ReplyToAThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Show category
     * @param {number} forumCategoryId The ID of the forumCategory.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    showCategoryRaw(requestParameters: ShowCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowCategory200Response>>;

    /**
     * 
     * Show category
     */
    showCategory(requestParameters: ShowCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowCategory200Response>;

    /**
     * 
     * @summary Show thread
     * @param {number} forumThreadId The ID of the forumThread.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    showThreadRaw(requestParameters: ShowThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowThread200Response>>;

    /**
     * 
     * Show thread
     */
    showThread(requestParameters: ShowThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowThread200Response>;

    /**
     * 
     * @summary Update thread
     * @param {number} forumThreadId The ID of the forumThread.
     * @param {UpdateThreadRequest} [updateThreadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumApiInterface
     */
    updateThreadRaw(requestParameters: UpdateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Update thread
     */
    updateThread(requestParameters: UpdateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ForumApi extends runtime.BaseAPI implements ForumApiInterface {

    /**
     * Pass an optional `car_id` to link the thread to a car. The thread still shows up in the global forum listing; the car link is additive. The car owner or any approved contributor (see `POST /cars/{car}/contributors`) may attach a car to a thread.
     * Create thread
     */
    async createThreadRaw(requestParameters: CreateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'createThreadRequest',
                'Required parameter "createThreadRequest" was null or undefined when calling createThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/threads`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateThreadRequestToJSON(requestParameters['createThreadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Pass an optional `car_id` to link the thread to a car. The thread still shows up in the global forum listing; the car link is additive. The car owner or any approved contributor (see `POST /cars/{car}/contributors`) may attach a car to a thread.
     * Create thread
     */
    async createThread(requestParameters: CreateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createThreadRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Delete a post (owner only)
     */
    async deleteAPostownerOnlyRaw(requestParameters: DeleteAPostownerOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['forumPostId'] == null) {
            throw new runtime.RequiredError(
                'forumPostId',
                'Required parameter "forumPostId" was null or undefined when calling deleteAPostownerOnly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/posts/{forumPost_id}`;
        urlPath = urlPath.replace(`{${"forumPost_id"}}`, encodeURIComponent(String(requestParameters['forumPostId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Delete a post (owner only)
     */
    async deleteAPostownerOnly(requestParameters: DeleteAPostownerOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAPostownerOnlyRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Delete thread
     */
    async deleteThreadRaw(requestParameters: DeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['forumThreadId'] == null) {
            throw new runtime.RequiredError(
                'forumThreadId',
                'Required parameter "forumThreadId" was null or undefined when calling deleteThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/threads/{forumThread_id}`;
        urlPath = urlPath.replace(`{${"forumThread_id"}}`, encodeURIComponent(String(requestParameters['forumThreadId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Delete thread
     */
    async deleteThread(requestParameters: DeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteThreadRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * List forum categories
     */
    async listForumCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForumCategories200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/categories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListForumCategories200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List forum categories
     */
    async listForumCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForumCategories200Response> {
        const response = await this.listForumCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * List forum threads
     */
    async listForumThreadsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForumThreads200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/threads`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListForumThreads200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List forum threads
     */
    async listForumThreads(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForumThreads200Response> {
        const response = await this.listForumThreadsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * List posts in a thread
     */
    async listPostsInAThreadRaw(requestParameters: ListPostsInAThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPostsInAThread200Response>> {
        if (requestParameters['forumThreadId'] == null) {
            throw new runtime.RequiredError(
                'forumThreadId',
                'Required parameter "forumThreadId" was null or undefined when calling listPostsInAThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/threads/{forumThread_id}/posts`;
        urlPath = urlPath.replace(`{${"forumThread_id"}}`, encodeURIComponent(String(requestParameters['forumThreadId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPostsInAThread200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List posts in a thread
     */
    async listPostsInAThread(requestParameters: ListPostsInAThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPostsInAThread200Response> {
        const response = await this.listPostsInAThreadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Reply to a thread
     */
    async replyToAThreadRaw(requestParameters: ReplyToAThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['forumThreadId'] == null) {
            throw new runtime.RequiredError(
                'forumThreadId',
                'Required parameter "forumThreadId" was null or undefined when calling replyToAThread().'
            );
        }

        if (requestParameters['replyToAThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'replyToAThreadRequest',
                'Required parameter "replyToAThreadRequest" was null or undefined when calling replyToAThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/threads/{forumThread_id}/posts`;
        urlPath = urlPath.replace(`{${"forumThread_id"}}`, encodeURIComponent(String(requestParameters['forumThreadId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReplyToAThreadRequestToJSON(requestParameters['replyToAThreadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Reply to a thread
     */
    async replyToAThread(requestParameters: ReplyToAThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replyToAThreadRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Show category
     */
    async showCategoryRaw(requestParameters: ShowCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowCategory200Response>> {
        if (requestParameters['forumCategoryId'] == null) {
            throw new runtime.RequiredError(
                'forumCategoryId',
                'Required parameter "forumCategoryId" was null or undefined when calling showCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/categories/{forumCategory_id}`;
        urlPath = urlPath.replace(`{${"forumCategory_id"}}`, encodeURIComponent(String(requestParameters['forumCategoryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowCategory200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Show category
     */
    async showCategory(requestParameters: ShowCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowCategory200Response> {
        const response = await this.showCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Show thread
     */
    async showThreadRaw(requestParameters: ShowThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowThread200Response>> {
        if (requestParameters['forumThreadId'] == null) {
            throw new runtime.RequiredError(
                'forumThreadId',
                'Required parameter "forumThreadId" was null or undefined when calling showThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/threads/{forumThread_id}`;
        urlPath = urlPath.replace(`{${"forumThread_id"}}`, encodeURIComponent(String(requestParameters['forumThreadId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowThread200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Show thread
     */
    async showThread(requestParameters: ShowThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowThread200Response> {
        const response = await this.showThreadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Update thread
     */
    async updateThreadRaw(requestParameters: UpdateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['forumThreadId'] == null) {
            throw new runtime.RequiredError(
                'forumThreadId',
                'Required parameter "forumThreadId" was null or undefined when calling updateThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/forum/threads/{forumThread_id}`;
        urlPath = urlPath.replace(`{${"forumThread_id"}}`, encodeURIComponent(String(requestParameters['forumThreadId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateThreadRequestToJSON(requestParameters['updateThreadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Update thread
     */
    async updateThread(requestParameters: UpdateThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateThreadRaw(requestParameters, initOverrides);
    }

}
